import { render, staticRenderFns } from "./AssignmentEntry.vue?vue&type=template&id=a9d4b03e&"
import script from "./AssignmentEntry.vue?vue&type=script&lang=js&"
export * from "./AssignmentEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports